import { createSlice } from "@reduxjs/toolkit";
import type { Dictionary } from "lodash";
import keyBy from "lodash/keyBy";
import { CostCategory } from "dora-contracts";
import { createErrorReportingAsyncThunk } from "../../helpers";
import * as api from "../../../pages/InsightsPage/insights-costs-api";

const prefix = "data/insightCostCategories";

type State = {
  entities: Dictionary<CostCategory>;
  ids: string[];
};

const initialState: State = {
  entities: {},
  ids: [],
};

export const loadInsightCostCategories = createErrorReportingAsyncThunk(
  `${prefix}/load`,
  async () => api.listCategories()
);

export const createInsightCostCategory = createErrorReportingAsyncThunk(
  `${prefix}/create`,
  async (input: { name: string }) => api.createCategory(input)
);

export const deleteInsightCostCategory = createErrorReportingAsyncThunk(
  `${prefix}/delete`,
  async (id: string) => {
    await api.deleteCategory(id);
    return id;
  }
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadInsightCostCategories.fulfilled, (state, action) => {
        state.entities = keyBy(action.payload, "id");
        state.ids = action.payload.map((x) => x.id);
      })
      .addCase(createInsightCostCategory.fulfilled, (state, action) => {
        const category = action.payload;
        state.entities[category.id] = category;
        state.ids.unshift(category.id);
      })
      .addCase(deleteInsightCostCategory.fulfilled, (state, action) => {
        const id = action.payload;
        delete state.entities[id];
        state.ids = state.ids.filter((x) => x !== id);
      });
  },
});

export default slice.reducer;
